
import { defineComponent, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  DeleteUserService
} from '@/views/dashboard/_components/central-control/_components/delete-user/delete-user.service'
import { Team, TeamInfo } from '@/services/team'
import { ElMessage } from 'element-plus'
import SmsVerify from '@/views/_components/sms-verify/sms-verify.vue'
import { User } from '@/services/user'
import { toLoginPage } from '@/services/login.service'

export default defineComponent({
  components: {
    SmsVerify
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    }
  },

  setup (props, context) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([DeleteUserService])
    const service = injector.get(DeleteUserService)
    const team = injector.get(Team)
    const userService = injector.get(User)

    const teamList = ref<TeamInfo[]>([])
    const smsVerifyVisible = ref(false)
    const mobile = ref('')

    userService.userInfo.subscribe(res => {
      mobile.value = res.mobile
    })

    team.teamList.subscribe(list => {
      teamList.value = list.filter(v => v.is_creator)
    })

    function deleteUser () {
      if (mobile.value) {
        handleClose()
        smsVerifyVisible.value = true
      } else {
        confirmDeleteUser()
      }
    }

    function confirmDeleteUser (data = {} as any) {
      service.deleteUser({ code: data.code }).then(() => {
        ElMessage.success(t('deleteUser.deleteSuccess'))
        // 账号已删除，本地登录态同样需要清理（userInfo/currentTeam/token）
        toLoginPage(true)
      })
    }

    function handleClose () {
      context.emit('update:modelValue', false)
    }

    watch(() => props.modelValue, (value) => {
      if (value) {
        team.refreshTeamList()
        userService.updateRemoteUserInfo()
      }
    }, { immediate: true })

    return {
      teamList,
      smsVerifyVisible,
      deleteUser,
      confirmDeleteUser,
      handleClose,
    }
  }
})
